import React from "react";
import { Chip, Grid, Typography } from "@mui/material";
const HeadingTree = ({ data }) => {
    return (React.createElement(Grid, { container: true, flexDirection: "row", justifyContent: "flex-start" },
        React.createElement(Chip, { label: data.tagName, sx: { marginBottom: "5px", marginRight: "2px" } }),
        React.createElement(Typography, { variant: "caption", sx: { paddingTop: "5px" } }, data.innerText),
        data.children.length > 0 &&
            data.children.map((child, index) => (React.createElement(HeadingTree, { key: index, data: child })))));
};
export default HeadingTree;
//# sourceMappingURL=HeadingTree.js.map